import axiosInstance from "../api/api";

const AuditService = {
    listQuestions: function () {
        return axiosInstance({
            url: "/api/auditQuestion/tenant",
            method: "GET",
        });
    },
    submitQuestionaire : function (formData) {
        return axiosInstance({
            url: "/api/auditQuestion/",
            method: "POST",
            data: formData
        })
    },
    getAnswer: function (uniqueId) {
        return axiosInstance({
            url: `/api/auditQuestion/${uniqueId}`,
            method: "GET",
        });
    },
    listAnswers: function (){
        return axiosInstance({
            url: "/api/auditQuestion/answers",
            method: "GET",
        });
    },
    deleteAnswer: function (uniqueId){
        return axiosInstance({
            url: `/api/auditQuestion/answers/${uniqueId}`,
            method: "DELETE",
        });
    }

};
export default AuditService;
